import { __awaiter, __generator, __assign } from '../node_modules/tslib/tslib.es6.js';
import { authAxiosInstance } from '@cheetahdigital/cesauth-core-lib';
import { getChangeBusinessUnitRedirectUrl } from '../contexts/ChangeBusinessUnitModalProvider.js';
import { getJWTPublicClaim, getRoles } from '../shared/utils/jwt.js';

var API_ORGANIZATIONS = "/adm/user/organization";
var API_USER = "/adm/user/";
var getOrganizations = function (baseURL) { return __awaiter(void 0, void 0, void 0, function () {
    var data, organizations, organization, _a, _b, default_org_id, _c, roles;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                return [4 /*yield*/, authAxiosInstance.get(API_ORGANIZATIONS, {
                        baseURL: baseURL
                    })];
            case 1:
                data = (_d.sent()).data;
                organizations = data.data;
                organization = organizations.find(function (_a) {
                    var selected = _a.selected;
                    return selected;
                });
                if (!organization) {
                    _a = getJWTPublicClaim(), _b = _a.default_org_id, default_org_id = _b === void 0 ? 0 : _b, _c = _a.roles, roles = _c === void 0 ? [] : _c;
                    return [2 /*return*/, {
                            organization: {
                                orgId: Number(default_org_id),
                                orgName: "",
                                buId: 0,
                                buName: "",
                                selected: true,
                                isDefault: true,
                                roleName: roles[0]
                            },
                            organizations: organizations
                        }];
                }
                return [2 /*return*/, {
                        organization: organization,
                        organizations: organizations
                    }];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getUser = function (id, baseURL) {
    if (id === void 0) { id = "me"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data, roles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authAxiosInstance.get(API_USER + id, {
                            baseURL: baseURL
                        })];
                case 1:
                    data = (_a.sent()).data;
                    roles = getRoles();
                    return [2 /*return*/, __assign(__assign({}, data), { roles: roles })];
                case 2:
                    _a.sent();
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    });
};
var switchBusinessUnit = function (_a) {
    var buId = _a.buId, platformId = _a.platformId;
    return __awaiter(void 0, void 0, void 0, function () {
        var redirectUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    redirectUrl = getChangeBusinessUnitRedirectUrl({ platformId: platformId, buId: buId });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, authAxiosInstance.get(redirectUrl, {
                            withCredentials: true
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var userService = {
    getUser: getUser,
    getOrganizations: getOrganizations,
    switchBusinessUnit: switchBusinessUnit
};

export { userService as default };
